import { Col, Row } from "antd";
import classNames from "classnames";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import Input from "../../Components/Input";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import InputChecked from "../../Components/svg/check_small.svg";
import InputError from "../../Components/svg/error.svg";
import validation from "./validation";
import Button from "../../Components/Button";
import InfoBox from "../../Components/InfoBox";
import QuickActionRed from "shared/components/SVG/LMF/QuickActionRed";
import { NAME_SPACES } from "shared/locales/constants";
import { useTranslation } from "react-i18next";

const View = ({ contact, setOpen, onSubmit, trigger, TRANSLATION }) => {
  const { t } = useTranslation();
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      contact: {
        telecoms: get(contact, "telecoms", {}),
        // user: get(contact, "user", {}),
        fields: {
          acceptContact: get(contact, "fields.acceptContact") || false,
          acceptDigital: get(contact, "fields.acceptDigital") || false,
        },
      },
    },
    onSubmit,
    enableReinitialize: true,
    validateOnMount: true,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });

  return (
    <div className="lmfhelp__modal--content">
      <div className="lmfhelp__modal--head">
        <span
          className="lmfhelp__modal--title"
          dangerouslySetInnerHTML={{ __html: TRANSLATION.TITLE_QUALIFICATION }}
        ></span>
        <p
          className="lmfhelp__modal--desc"
          dangerouslySetInnerHTML={{
            __html:
              trigger === "replaceContract"
                ? TRANSLATION.DESCRIPTION_OLD_CONTRACT
                : TRANSLATION.DESCRIPTION,
          }}
        />
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label={TRANSLATION.FORM.PHONE.LABEL}
            placeholder={TRANSLATION.FORM.PHONE.PLACEHOLDER}
            inputMode="numeric"
            {...bindInputProps({
              name: `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
              values,
              setFieldValue,
              ...formProps,
            })}
            onChange={({ target: { value } }) => {
              setFieldValue(
                `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                value,
              );
            }}
            className={classNames({
              valid: get(
                values,
                `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
              ),
            })}
            suffix={
              get(
                formProps.errors,
                `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
              ) ? (
                <img src={InputError} alt="" />
              ) : (
                <img src={InputChecked} alt="" />
              )
            }
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label={TRANSLATION.FORM.EMAIL.LABEL}
            placeholder={TRANSLATION.FORM.EMAIL.PLACEHOLDER}
            inputMode="numeric"
            {...bindInputProps({
              name: `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
              values,
              setFieldValue,
              ...formProps,
            })}
            onChange={({ target: { value } }) => {
              setFieldValue(
                `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                value,
              );
            }}
            className={classNames({
              valid: get(
                values,
                `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
              ),
            })}
            suffix={
              get(
                formProps.errors,
                `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
              ) ? (
                <img src={InputError} alt="" />
              ) : (
                <img src={InputChecked} alt="" />
              )
            }
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Input
            type="checkbox"
            label={TRANSLATION.FORM.OPT_INS.CONTACT}
            {...bindInputProps({
              name: "contact.fields.acceptContact",
              values,
              ...formProps,
            })}
            onChange={({ target: { checked } }) => {
              setFieldValue("contact.fields.acceptContact", checked);
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Input
            type="checkbox"
            label={TRANSLATION.FORM.OPT_INS.MAIL_ME}
            {...bindInputProps({
              name: "contact.fields.acceptDigital",
              values,
              ...formProps,
            })}
            onChange={({ target: { checked } }) => {
              setFieldValue("contact.fields.acceptDigital", checked);
            }}
          />
        </Col>
      </Row>

      <InfoBox
        text={TRANSLATION.INFO}
        icon={<QuickActionRed />}
        variant="danger"
      />

      <div className="lmfhelp__modal--actions">
        <Button onClick={() => setOpen(false)} type="white" size="large">
          <span>{TRANSLATION.CLOSE}</span>
        </Button>
        <Button
          disabled={!formProps.isValid}
          onClick={handleSubmit}
          type={!formProps.isValid ? "white" : "primary"}
          size="large"
        >
          <span>{TRANSLATION.CONFIRM}</span>
        </Button>
      </div>
    </div>
  );
};

export default View;
